import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { PaymentService } from 'src/app/admin/services/payment.service';
import { AppUtils } from 'src/app/helpers/app.utils';
import { ContributorPaymentUpsertModel } from 'src/app/admin/models/contributer.payment.upsert.model';

@Component({
    selector: 'app-contributor-payment-log-upsert',
    templateUrl: './contributor.payment.log.upsert.component.html'
})
export class ContributorPaymentLogUpsertComponent implements OnInit {
    @Input() public contributorId;
    remainingAmount: number;

    model = new ContributorPaymentUpsertModel();

    constructor(public activeModal: NgbActiveModal,
        private toastr: ToastrService,
        private paymentService: PaymentService,
        private ngxSpinnerService: NgxSpinnerService) {

    }

    ngOnInit(): void {
        setTimeout(() => {
            this.getRemainingAmount();
        });
    }

    getRemainingAmount() {
        this.ngxSpinnerService.show();
        this.paymentService.getContributorRemainingAmount(this.contributorId).subscribe(
            res => {
                this.remainingAmount = Number(res.toFixed(2));
                this.ngxSpinnerService.hide();
            }, error => {
                this.ngxSpinnerService.hide();
                AppUtils.processErrorResponse(this.toastr, error);
            });
    }

    close(): void {
        this.activeModal.close();
    }

    submit(): void {
        this.model.contributorId = this.contributorId;
        this.ngxSpinnerService.show();
        this.paymentService.addContributorPaymentLog(this.model).subscribe(
            () => {
                this.ngxSpinnerService.hide();
                this.activeModal.close();
                this.toastr.success('Payment added successfully.');
            }, error => {
                this.ngxSpinnerService.hide();
                AppUtils.processErrorResponse(this.toastr, error);
            });
    }
}
